/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckAdresseId } from './grundstueckAdresseId';
import { GrundstueckId } from './grundstueckId';
import { HistInfo } from './histInfo';
import { EditableVersion } from './editableVersion';
import { OrtschaftListEntry } from './ortschaftListEntry';


export interface GrundstueckadresseDetailEntry { 
    id: GrundstueckAdresseId;
    histInfo?: HistInfo;
    adressText?: string;
    grundstueckId: GrundstueckId;
    ortschaft?: OrtschaftListEntry;
    lagebezeichnungsTyp?: GrundstueckadresseDetailEntry.LagebezeichnungsTypEnum;
    editActions?: Array<GrundstueckadresseDetailEntry.EditActionsEnum>;
    modificationCounter: number;
    rubrikUebergeben?: boolean;
    grundstueckIds?: Array<GrundstueckId>;
    domaene?: GrundstueckadresseDetailEntry.DomaeneEnum;
    versions?: Array<EditableVersion>;
}
export namespace GrundstueckadresseDetailEntry {
    export type LagebezeichnungsTypEnum = 'FLURNAME' | 'ORTSNAME' | 'STRASSE';
    export const LagebezeichnungsTypEnum = {
        FLURNAME: 'FLURNAME' as LagebezeichnungsTypEnum,
        ORTSNAME: 'ORTSNAME' as LagebezeichnungsTypEnum,
        STRASSE: 'STRASSE' as LagebezeichnungsTypEnum
    };
    export type EditActionsEnum = 'AENDERN' | 'KORRIGIEREN' | 'STREICHEN' | 'STORNIEREN';
    export const EditActionsEnum = {
        AENDERN: 'AENDERN' as EditActionsEnum,
        KORRIGIEREN: 'KORRIGIEREN' as EditActionsEnum,
        STREICHEN: 'STREICHEN' as EditActionsEnum,
        STORNIEREN: 'STORNIEREN' as EditActionsEnum
    };
    export type DomaeneEnum = 'AV' | 'GB' | 'NA';
    export const DomaeneEnum = {
        AV: 'AV' as DomaeneEnum,
        GB: 'GB' as DomaeneEnum,
        NA: 'NA' as DomaeneEnum
    };
}


